"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _link["default"];
  }
});
Object.defineProperty(exports, "SpanLink", {
  enumerable: true,
  get: function get() {
    return _spanLink["default"];
  }
});
var _link = _interopRequireDefault(require("./link"));
var _spanLink = _interopRequireDefault(require("./span-link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }